/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Pw_Check2Inputs */

const en_funnel_pw_check2 = /** @type {(inputs: Funnel_Pw_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skips citations and footnotes, up to 3x speed`)
};

const es_funnel_pw_check2 = /** @type {(inputs: Funnel_Pw_Check2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omite citas y notas al pie, hasta 3 veces la velocidad normal`)
};

/**
* | output |
* | --- |
* | "Skips citations and footnotes, up to 3x speed" |
*
* @param {Funnel_Pw_Check2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_check2 = /** @type {((inputs?: Funnel_Pw_Check2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_Check2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_check2(inputs)
	return en_funnel_pw_check2(inputs)
});